import { render } from "./index.vue?vue&type=template&id=9844b294"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\avue\\avue3.0\\avue\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.5.12_vue@3.5.27_typescript@5.9.3__webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"packages/element-plus/checkbox/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9844b294"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9844b294', __exports__)) {
    console.log('reload')
    api.reload('9844b294', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=9844b294", () => {
    console.log('re-render')
    api.rerender('9844b294', render)
  })

}


export default __exports__